<template>
  <div class="lbd-page">
    <el-card shadow="never">
      <template #header>
        <span class="page-title">不动产查询订单列表</span>
      </template>

      <!--搜索筛选区域-->
      <el-form :model="searchForm" inline class="search-wrap">
        <el-form-item label="订单号">
          <el-input v-model="searchForm.orderNo" placeholder="请输入订单号" clearable />
        </el-form-item>
        <el-form-item label="主账号名">
          <el-input v-model="searchForm.company_name" placeholder="主账号名" clearable />
        </el-form-item>
        <el-form-item label="子账号名">
          <el-input v-model="searchForm.sub_name" placeholder="子账号名" clearable />
        </el-form-item>
        <el-form-item label="lab">
          <el-input v-model="searchForm.lab" placeholder="lab" clearable />
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="searchForm.name" placeholder="姓名" clearable />
        </el-form-item>
        <el-form-item label="身份证">
          <el-input v-model="searchForm.cardid" placeholder="身份证号" clearable />
        </el-form-item>
        <el-form-item label="上游结果status">
          <el-select v-model="searchForm.status" placeholder="全部" clearable>
            <el-option label="失败" :value="0" />
            <el-option label="完成" :value="1" />
            <el-option label="进行中" :value="2" />
            <el-option label="订单过期" :value="3" />
          </el-select>
        </el-form-item>
        <el-form-item label="风控干预state">
          <el-select v-model="searchForm.state" placeholder="全部" clearable>
            <el-option label="审核驳回" :value="0" />
            <el-option label="待审核" :value="1" />
            <el-option label="审核通过" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="是否已处理">
          <el-select v-model="searchForm.jieguo" placeholder="全部" clearable>
            <el-option label="未处理" :value="0" />
            <el-option label="已处理" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item label="时间维度">
          <el-select v-model="searchForm.type" placeholder="全部" clearable @change="onTimeTypeChange">
            <el-option label="日" value="day" />
            <el-option label="周" value="week" />
            <el-option label="月" value="month" />
            <el-option label="自定义" value="custom" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="searchForm.type === 'custom'">
          <el-date-picker
            v-model="timeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="YYYY-MM-DD"
            clearable
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>

      <!--表格-->
      <el-table :data="tableList" border stripe style="width:100%" v-loading="loading">
        <el-table-column label="订单号" min-width="140" show-overflow-tooltip>
          <template #default="{ row }">
            <span class="copy-cell" @dblclick="handleCopy(row.orderNo)">
              {{ row.orderNo }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="商品名称" min-width="140" show-overflow-tooltip>
          <template #default="{ row }">
            <span class="copy-cell" @dblclick="handleCopy(row.goodsname)">
              {{ row.goodsname }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="主账号企业" min-width="140" show-overflow-tooltip>
          <template #default="{ row }">
            <span class="copy-cell" @dblclick="handleCopy(row.company_main)">
              {{ row.company_main }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="子账号" width="80" show-overflow-tooltip>
          <template #default="{ row }">
            <span class="copy-cell" @dblclick="handleCopy(row.company_sub)">
              {{ row.company_sub }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="姓名" width="100">
          <template #default="{ row }">
            <span class="copy-cell" @dblclick="handleCopy(row.name)">
              {{ row.name }}
            </span>
          </template>
        </el-table-column>
        <!--身份证脱敏 保留前6后4-->
        <el-table-column label="身份证" width="160">
          <template #default="{ row }">
            <span class="copy-cell" @dblclick="handleCopy(maskIdCard(row.cardid))">
              {{ maskIdCard(row.cardid) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="resultSize" label="核验数值" width="130" show-overflow-tooltip/>
        
        <!-- 风控干预状态state（主要展示，带颜色标签） -->
        <el-table-column label="风控状态" width="100">
          <template #default="{ row }">
            <el-tag :type="getStateTag(row.state)">{{ getStateText(row.state) }}</el-tag>
          </template>
        </el-table-column>

        <!-- 上游数据结果status -->
        <el-table-column label="结果状态" width="100">
          <template #default="{ row }">
            <el-tag :type="getStatusTag(row.status)">{{ getStatusText(row.status) }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="create_time" label="创建时间" width="130" show-overflow-tooltip/>
        <el-table-column prop="verify_time" label="核验时间" width="130" show-overflow-tooltip/>
        <el-table-column prop="req_time" label="结果时间" width="130" show-overflow-tooltip/>
        <el-table-column label="操作" width="100">
          <template #default="{ row }">
            <el-button link type="primary" @click="viewDetail(row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--分页-->
      <el-pagination
        v-model:current-page="pageInfo.page"
        v-model:page-size="pageInfo.pageSize"
        :total="pageInfo.total"
        :page-sizes="[10,20,50]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSearch"
        @current-change="handleSearch"
        class="pagination-wrap"
      />
    </el-card>

    <!--详情弹窗-->
    <el-dialog v-model="detailVisible" title="订单详情" width="720px">
      <el-descriptions :column="2" border v-if="currentRow">
        <el-descriptions-item label="订单号">
          <span class="copy-cell" @dblclick="handleCopy(currentRow.orderNo)">{{currentRow.orderNo}}</span>
        </el-descriptions-item>
        <el-descriptions-item label="商品">{{currentRow.goodsname}}</el-descriptions-item>
        <el-descriptions-item label="主账号企业">{{currentRow.company_main}}</el-descriptions-item>
        <el-descriptions-item label="子账号">{{currentRow.company_sub}}</el-descriptions-item>
        <el-descriptions-item label="姓名">{{currentRow.name}}</el-descriptions-item>
        <el-descriptions-item label="身份证">
          <span class="copy-cell" @dblclick="handleCopy(currentRow.cardid)">{{ currentRow.cardid }}</span>
        </el-descriptions-item>

        <el-descriptions-item label="风控状态">
          <el-tag :type="getStateTag(currentRow.state)">{{ getStateText(currentRow.state) }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="结果状态">
          <el-tag :type="getStatusTag(currentRow.status)">{{ getStatusText(currentRow.status) }}</el-tag>
        </el-descriptions-item>
        <!-- state_tips仅弹窗显示 -->
        <el-descriptions-item label="状态提示">{{ currentRow.state_tips || "-" }}</el-descriptions-item>

        <el-descriptions-item label="创建时间">{{currentRow.create_time}}</el-descriptions-item>
        <el-descriptions-item label="核验时间">{{currentRow.verify_time}}</el-descriptions-item>
        <el-descriptions-item label="过期时间">{{currentRow.expire_time || '-'}}</el-descriptions-item>
      </el-descriptions>
      <template #footer>
        <el-button @click="detailVisible = false">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { ElMessage } from "element-plus";
import { getLBDlist } from "@/api/api";

const loading = ref(false);
const tableList = ref([]);
const detailVisible = ref(false);
const currentRow = ref(null);
const timeRange = ref([]);

//搜索表单，严格对齐接口入参
const searchForm = ref({
  page: 1,
  pageSize: 10,
  orderNo: "",
  company_name: "",
  sub_name: "",
  lab: "",
  status: null,
  state: null,
  name: "",
  cardid: "",
  jieguo: null,
  type: "",
  starttime: "",
  endtime: ""
});

const pageInfo = ref({
  page: 1,
  pageSize: 10,
  total: 0
})

const onTimeTypeChange = () => {
  timeRange.value = []
  searchForm.value.starttime = ""
  searchForm.value.endtime = ""
}

/**
 * 双击复制文本
 */
const handleCopy = async (text) => {
  if (!text) return;
  try {
    await navigator.clipboard.writeText(text);
    ElMessage.success("已复制到剪贴板");
  } catch (err) {
    ElMessage.error("复制失败，请手动复制");
  }
};

/**
 * 身份证脱敏 前6 **** 后4
 */
const maskIdCard = (idCard) => {
  if (!idCard) return "-";
  if (idCard.length <= 10) return idCard;
  return idCard.slice(0, 6) + "********" + idCard.slice(-4);
};

/**
 * state：干预状态（风控审核，主要显示）
 * 0 审核驳回；1 待审核；2 审核通过
 */
const getStateText = (val) => {
  const map = { 0: "审核驳回", 1: "待审核", 2: "审核通过" };
  return map[val] ?? "未知";
};
const getStateTag = (val) => {
  const map = { 0: "danger", 1: "warning", 2: "success" };
  return map[val] ?? "info";
};

/**
 * status：上游数据结果状态
 * 0失败；1完成；2进行中;3订单过期
 */
const getStatusText = (val) => {
  const map = { 0: "失败", 1: "完成", 2: "进行中", 3: "订单过期" };
  return map[val] ?? "未知";
};
const getStatusTag = (val) => {
  const map = { 0: "danger", 1: "success", 2: "primary", 3: "info" };
  return map[val] ?? "info";
};

//查询列表
const handleSearch = async () => {
  loading.value = true;
  // 组装完整接口参数
  const params = {
    page: pageInfo.value.page,
    pageSize: pageInfo.value.pageSize,
    orderNo: searchForm.value.orderNo,
    company_name: searchForm.value.company_name,
    sub_name: searchForm.value.sub_name,
    lab: searchForm.value.lab,
    status: searchForm.value.status,
    state: searchForm.value.state,
    name: searchForm.value.name,
    cardid: searchForm.value.cardid,
    jieguo: searchForm.value.jieguo,
    type: searchForm.value.type,
    starttime: searchForm.value.starttime,
    endtime: searchForm.value.endtime
  }
  // 自定义时间，回填起止时间
  if(searchForm.value.type === "custom" && timeRange.value?.length ===2){
    params.starttime = timeRange.value[0]
    params.endtime = timeRange.value[1]
  }
  try {
    const res = await getLBDlist(params);
    console.log(res);
    if (res.code === 200 && res.subcode === 200001) {
      tableList.value = res.data.list || [];
      pageInfo.value.total = res.data.total;
      pageInfo.value.pageSize = res.data.pageSize;
    }
  } catch (err) {
    console.error(err)
  } finally {
    loading.value = false
  }
}

//重置
const resetSearch = () => {
  searchForm.value = {
    page: 1,
    pageSize: 10,
    orderNo: "",
    company_name: "",
    sub_name: "",
    lab: "",
    status: null,
    state: null,
    name: "",
    cardid: "",
    jieguo: null,
    type: "",
    starttime: "",
    endtime: ""
  }
  timeRange.value = []
  pageInfo.value.page = 1;
  handleSearch()
}

//查看详情
const viewDetail = (row) => {
  currentRow.value = row;
  detailVisible.value = true;
}

onMounted(() => {
  handleSearch()
})

</script>

<style scoped>
.lbd-page {
  padding: 16px;
}
.page-title {
  font-size: 16px;
  font-weight: bold;
}
.search-wrap {
  margin-bottom: 16px;
}
.pagination-wrap {
  margin-top: 16px;
  text-align: right;
}
.copy-cell {
  cursor: copy;
}
</style>
